// FilteringCard.tsx

import { Box } from '@mui/material'
import React, { ReactElement, PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import SidePanel from 'src/components/SidePanel'

import BaseButton from '../BaseButton'

import CardBase from './CardBase'

export interface IFilteringCardProps {
  SideComponent: ReactElement<typeof SidePanel>
  onApplyFilter: () => void
}

export function FilteringCard({ SideComponent, onApplyFilter, children }: PropsWithChildren<IFilteringCardProps>) {
  const { t } = useTranslation()

  return (
    <CardBase>
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          borderRight: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Box
          id="side-component-container"
          marginBottom={`5rem`}
          flex="1"
          overflow={'hidden'}
          borderBottom={'thin solid'}
          borderColor={'divider'}
        >
          {SideComponent}
        </Box>

        <Box
          width="100%"
          position="absolute"
          bottom={0}
          right={0}
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ px: 2, py: 5 }}
          height={'5rem'}
        >
          <BaseButton
            id="btn-apply-filters"
            onClick={onApplyFilter}
            sx={{ fontSize: 12, width: '100%', fontWeight: 'bold' }}
          >
            {t('commons.buttons.filters.apply_filter')}
          </BaseButton>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, overflowY: 'scroll', overflowX: 'auto' }}>
        {children}
      </Box>
    </CardBase>
  )
}
